import Axios from "axios";
import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import PageNav from "./components/PageNav";
import SingleReview from "./components/SingleReview";
import Schema from "./components/Schema";
import WriteReview from "./components/WriteReview";
import Aggregate from "./components/Aggregate";
import HeadLinks from "./components/HeadLinks";
import Loader from "./assets/loader.gif";
import "./App.scss";
function App() {
  const [reviewData, setReviewData] = useState([]);
  const [BusinessData, setBusinessData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pageCount, setPageCount] = useState();
  useEffect(() => {
    fetchreviewData();
    fetchBusinessData();
  }, []);
  const fetchreviewData = async () => {
    const response = await Axios.get(
      "/wp-content/plugins/lrm-reviews/review-results.json"
    );

    setReviewData(response.data);
    var countArray = [];

    for (var i = 1; i <= Math.floor(response.data.length / 10); i++) {
      countArray.push(i);
    }
    countArray.slice(0, -1);
    setPageCount(countArray);
    setLoading(false);
  };
  const fetchBusinessData = async () => {
    const response = await Axios.get(
      "/wp-content/plugins/lrm-reviews/business-results.json"
    );
    setBusinessData(response.data);
    setLoading(false);
  };

  let base = "";
  let regEx = /\/page\/*\d*/;
  let page = "";
  if (window.location.pathname.includes("page")) {
    base = window.location.pathname.replace(regEx, "");
    page = parseInt(window.location.pathname.match(/\d+/)[0]);
  } else {
    base = window.location.pathname;
    page = 1;
  }
  const baseReset = () => {
    base = "/";
    page = 1;
  };
  console.log("base: " + base, "page: ", page);
  if (loading) {
    return (
      <div className="text-center">
        <img alt="loading icon" src={Loader} />
      </div>
    );
  }
  if (!loading) {
    return (
      <>
        <div className="lrm-reviews-container" id="lrmReviews">
          <HeadLinks base={base} page={page} pageCount={pageCount} />
          <Aggregate
            reviewCount={BusinessData.reviewCount}
            avgRating={BusinessData.avgRating}
          />
          <div className="lrm-reviews-review-container">
            <WriteReview />
          </div>
          <Router basename={base}>
            <Switch>
              {pageCount &&
                pageCount.map((data) => {
                  return (
                    <Route exact path={`/page/${data}`}>
                      <SingleReview
                        reviewData={reviewData}
                        page={data}
                        totalPage={Math.floor(reviewData.length / 10)}
                      />
                      <PageNav
                        page={data}
                        reviewData={reviewData}
                        pageCount={pageCount}
                        currentPage={data}
                        totalPage={Math.floor(reviewData.length / 10)}
                        base={base}
                        baseReset={baseReset()}
                      />
                      <Schema
                        aggregateData={BusinessData}
                        reviewData={reviewData}
                        businessType={window.lrmSettings["business_type"]}
                        pageCount={pageCount}
                        page={data}
                      />
                    </Route>
                  );
                })}
              <Route exact path="/">
                <SingleReview
                  reviewData={reviewData}
                  page={page}
                  totalPage={Math.floor(reviewData.length / 10)}
                />
                <PageNav
                  page={page}
                  reviewData={reviewData}
                  pageCount={pageCount}
                  totalPage={Math.floor(reviewData.length / 10)}
                  base={base}
                />
                <Schema
                  aggregateData={BusinessData}
                  reviewData={reviewData}
                  businessType={window.lrmSettings["business_type"]}
                  pageCount={pageCount}
                  page={page}
                />
              </Route>
            </Switch>
          </Router>
        </div>
      </>
    );
  }
}

export default App;
